import { createSlice, createEntityAdapter } from '@reduxjs/toolkit';
import {
  createCategory,
  fetchCategories,
  removeCategory,
  updateCategory,
} from './action';

export const categoriesAdapter = createEntityAdapter({
  selectId: (caregory) => caregory._id,
});

const initialState = categoriesAdapter.getInitialState({
  status: 'idle', // 'idle' | 'loading' | 'succeeded' | 'failed'
});

export const lessonsSlice = createSlice({
  name: 'categories',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchCategories.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchCategories.fulfilled, (state, action) => {
        state.status = 'succeeded';
        categoriesAdapter.upsertMany(state, action.payload);
      })
      .addCase(fetchCategories.rejected, (state) => {
        state.status = 'failed';
      })
      .addCase(createCategory.fulfilled, (state, action) => {
        categoriesAdapter.addOne(state, action.payload);
      })
      .addCase(updateCategory.fulfilled, (state, { payload }) => {
        const { _id: id, ...changes } = payload;
        categoriesAdapter.updateOne(state, { id, changes });
      })
      .addCase(removeCategory.fulfilled, (state, action) => {
        categoriesAdapter.removeOne(state, action.payload._id);
      });
  },
});

export const { selectAll: selectAllCategories } =
  categoriesAdapter.getSelectors((state) => state.categories);

export default lessonsSlice.reducer;
